import { useMutation, useQueryClient } from 'react-query';

import Api from '../../api/api';

export const unpinCategory = async (categoryId: string) => {
  const [response, bodyOrError] = await Api.patch(`categories/${categoryId}/unpin`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useUnpinCategory = () => {
  const queryClient = useQueryClient();

  return useMutation(
    'unpinCategory',
    (categoryId: string) => {
      return unpinCategory(categoryId);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['getCategoriesByPage']);
        queryClient.invalidateQueries(['getSubCategoriesByPage']);
      },
    },
  );
};
